import React from "react";
import Card from "react-bootstrap/Card";
import { useIntl } from "react-intl";

import Establishments from "./Establishments.jsx";

const messages = {
  establishments: {
    id: "modules.EmailAddressEstablishment.components.Dashboard.establishments",
    description: "Email Address label.",
    defaultMessage: "Establishments",
  },
};

const Dashboard = () => {
  const { formatMessage } = useIntl();

  return (
    <Card>
      <Card.Header className="card-header-borderless" as="h3">
        {formatMessage(messages.establishments)}
      </Card.Header>
      <Card.Body>
        <Establishments />
      </Card.Body>
    </Card>
  );
};

export default Dashboard;
